import { loadGrecaptchaApi } from './load-grecaptcha-api';

export class Controller {

    /** @ngInject */
    constructor($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;
    }

    $onInit() {
        const parameters = {
            sitekey: window.env.captcha.key,
            callback: this.onResponse.bind(this),
            'expired-callback': this.onExpire.bind(this),
        };

        loadGrecaptchaApi().then((grecaptcha) => {
            const widgetId = grecaptcha.render(this.$element[0], parameters);
            this.state.widget = {reset: () => grecaptcha.reset(widgetId)};
        });
    }

    /** @private */
    onResponse(response) {
        this.$scope.$apply(() => this.state.response = response);
    }

    /** @private */
    onExpire() {
        this.$scope.$apply(() => this.state.response = undefined);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/captcha/sp-grecaptcha/sp-grecaptcha.controller.js